import {h} from 'preact'
import {useContext} from "preact/hooks";
import {HomeContext} from "../../context/HomeContext";
import SalonCard from "../blocks/SalonCard";
import {route} from "preact-router";

export default ({count, additionalClass = ''}) => {
    const {popularStylists, locations} = useContext(HomeContext);
    let city = locations.length === 1 && locations[0]?.name === 'Ghana' ? 'Accra' : 'Lagos'
    const openSalon = (id) => {
        route(`/stylists/${id}`)
    }
    return (
        <section className={`top-stylists ${additionalClass}`}>
            <div className="heading">
                <h2>Top <mark>Mirron</mark> stylists<br/>
                    in <mark className="underlined">{city}</mark></h2>
            </div>
            <div className="result-list">
                {popularStylists.slice(0, count).map(el => <SalonCard {...el} onClickExplore={openSalon} />)}

            </div>
        </section>
    )
}